/* eslint-disable prettier/prettier */
import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useUsers({ enabled = true, params }) {
  const page = params?.page || params?.firstResult || 0;
  const size = params?.size || params?.pageSize || 10;
  const sortOrder = params?.sortOrder || "desc";
  const sort = params?.sortBy
    ? `${params?.sortBy},${sortOrder}`
    : params?.sort
      ? `${params?.sort},${sortOrder}`
      : "";

  const queryParams = { page, size, sortOrder, sort };
  return useQuery({
    enabled,
    queryKey: ["users", queryParams],
    queryFn: async () => {
      const response = await customFetch(
        `/api/smartbpm/v1/{tenant}/users?${new URLSearchParams(queryParams)}`,
      );

      if (response?.error || (response?.status && response.status >= 400)) {
        throw new Error(response.message || "Failed to fetch users");
      }

      return response;
    }
  });
}

export function useUsersAndGroups({ enabled = true }) {
  return useQuery({
    enabled,
    queryKey: ["users-and-groups"],
    queryFn: async () =>
      customFetch(`/api/smartbpm/v1/{tenant}/users/list-users-and-groups`),
  });
}
